export const LayoutType = {
  Layout1: 1,
  Layout2: 2,
  Layout41: 41,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Layout1: "Layout1",
  Layout2: "Layout2",
  Layout41: "Layout41",
};

export const LayoutAbbreviations = [
  "Layout1",
  "Layout2",
  "Layout41",
];
export const LayoutAbbreviationsToRemove = [
  "Layout41",
  "Layout2",
  "Layout1",
];

export const METADATA = {
  ALL: "ALL"
};

export const DECORS_MAX = 10;

export const SLAT_WALL_POSITIONS = ["S1","S2","S3","S4"];
